export type PriceFormatter = (_price: string) => string

export const priceDefault: PriceFormatter = price => price
export const pricePerUnit: PriceFormatter = price => `${price} ea`
